import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import {Avatar, Button, Grid, List, ListItem, ListItemAvatar, Typography, useMediaQuery} from '@material-ui/core';
import {SectionHeader} from 'components/molecules';
import {Section} from 'components/organisms';
import clsx from "clsx"
import {Image} from "components/atoms";
import {showDemo} from "common";

const useStyles = makeStyles((theme) => ({
    fontWeight900: {
        fontWeight: 900,
    },
    fontWeight700: {
        fontWeight: 700,
    },
    noPaddingBottom: {
        paddingBottom: 0,
    },
    noPaddingTop: {
        paddingTop: 0,
    },
    bulletList: {
        marginLeft: theme.spacing(2),
        paddingLeft: theme.spacing(2)
    },
    list: {
        marginBottom: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
            marginBottom: theme.spacing(4),
        },
    }
}));

const features = [
    "Comply with ASC 606",
    "Get GAAP Revenue Faster",
    "Reduce Errors",
    "Improve Auditability",
    "Get Better Insights into Revenue",
    "Manage Growth"];

const Solution = ({className, ...rest}) => {
    const classes = useStyles();
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    
    const button = (
       <Button
          size="large"
          variant="contained"
          color="primary"
          onClick={() => window.open('https://www.chargebee.com/docs/revrec/quick-start.html')}>
           Get started
       </Button>
    );
    
    const demoButton = (
       <Button size="large" variant="outlined" color="primary" component="a" onClick={showDemo}>
           See Interactive Demo
       </Button>
    );
    
    return (
       <div className={className} {...rest}>
           <Section className={clsx(classes.noPaddingTop, classes.noPaddingBottom)}>
               <Grid container spacing={isMd ? 4 : 2} alignContent={'center'}>
                   <Grid item xs={12}>
                       <SectionHeader
                          title={<Typography variant="h3" component="span" className={classes.fontWeight900}
                                             color={"secondary"}>
                              REVLOCK &nbsp;
                              <Typography component="span" variant="h3" color="primary" className={classes.fontWeight700}>is your answer</Typography>
                          </Typography>}
                          subtitle={'Learn more about how you can Eliminate Manual Spreadsheets AND NOT Over-spend on Costly ERP Solutions'}
                          align="center"
                          titleProps={{
                              variant: 'h2',
                              color: 'textPrimary',
                          }}
                          data-aos="fade-up"
                          ctaGroup={[demoButton, button]}
                       />
                   </Grid>
               </Grid>
           </Section>
           <Section className={clsx(classes.noPaddingTop)}>
               <Grid
                  container
                  justify="space-between"
                  alignItems="flex-start"
                  spacing={4}
                  direction={isMd ? 'row' : 'column-reverse'}>
                   <Grid
                      item
                      container
                      alignItems="center"
                      xs={12}
                      md={6}
                      data-aos={'fade-up'}>
                       
                       <List className={classes.list}>
                           {features.map((item, index) => (
                              <ListItem disableGutters key={index} data-aos="fade-up">
                                  <ListItemAvatar>
                                      <Avatar
                                         src="https://assets.maccarianagency.com/the-front/illustrations/check-icon-yellow.svg"
                                         className={classes.checkBox}
                                      />
                                  </ListItemAvatar>
                                  <Typography variant="body1" color="textPrimary">
                                      {item}
                                  </Typography>
                              </ListItem>
                           ))}
                       </List>
                   </Grid>
                   <Grid
                      item
                      container
                      justify="flex-start"
                      alignItems="center"
                      xs={12}
                      md={6}
                      data-aos={'fade-up'}
                   >
                       <Image
                          hasZoom
                          src="https://s3.amazonaws.com/content.rev-lock.com/images/home_screen.png"
                          alt="RevLock Sales Contract"
                          className={classes.image}
                          data-aos="flip-left"
                          data-aos-easing="ease-out-cubic"
                          data-aos-duration="2000"
                       />
                   </Grid>
               
               </Grid>
           </Section>
       </div>
    );
};

Solution.propTypes = {
    /**
     * External classes
     */
    className: PropTypes.string,
};

export default Solution;
